export const FILE_FIELD_REMOVE_BUTTON_SELECTOR = '.file-field__upload .file-field__remove'
